import React from "react";
import ConfigChangesChart from "./ConfigChangesChart";
import MsbViolationsChart from "./MsbViolationsChart";

export function DeviceDetailsChartsSection() {
    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-md-6">
                    <ConfigChangesChart />
                </div>
                <div className="col-md-6">
                    <MsbViolationsChart />
                </div>
            </div>
        </div>
    )
}